import React from "react";

const LocationIcon16pxSvg = ({
    color = "#ffffff",
    width = 16,
    height = 16,
    ...props
}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg "{...props}>
            <g clip-path="url(#clip0_155851_63053)">
                <path d="M13.7467 5.63268C13.0467 2.55268 10.3601 1.16602 8.00006 1.16602C8.00006 1.16602 8.00006 1.16602 7.9934 1.16602C5.64006 1.16602 2.94673 2.54602 2.24673 5.62602C1.46673 9.06602 3.5734 11.9793 5.48006 13.8127C6.18673 14.4927 7.0934 14.8327 8.00006 14.8327C8.90673 14.8327 9.8134 14.4927 10.5134 13.8127C12.4201 11.9793 14.5267 9.07268 13.7467 5.63268ZM8.00006 8.97268C6.84006 8.97268 5.90006 8.03268 5.90006 6.87268C5.90006 5.71268 6.84006 4.77268 8.00006 4.77268C9.16006 4.77268 10.1001 5.71268 10.1001 6.87268C10.1001 8.03268 9.16006 8.97268 8.00006 8.97268Z" fill={color} />
            </g>
            <defs>
                <clipPath id="clip0_155851_63053">
                    <rect width={width} height={height} fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default LocationIcon16pxSvg;